import React from 'react';
import ReactDOM from 'react-dom/client';
import SolarSim from './SolarSim';

const rootnode = document.getElementById('simroot');
const approot = ReactDOM.createRoot(rootnode);
const initialProps = JSON.parse(rootnode.dataset.init?.length ? rootnode.dataset.init : '{}');
approot.render(
  <React.StrictMode>
    <SolarSim initialProps={initialProps}/>
  </React.StrictMode>
);